import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    workType: {
        type: "select",
        label: "Work Type",
        isRequired: true,
        options: [],
        isLoading: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    state: {
        type: "select",
        label: "State",
        isRequired: true,
        options: [],
        isLoading: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    city: {
        type: "select",
        label: "city",
        isRequired: true,
        options: [],
        isLoading: false,
        xs:12,
        lg:3,
        sm:6,
        md:3,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
};

export default FIELDS;